module.exports = __webpack_public_path__ + "img/pcbanner_2025.13bdc4c4.jpg";